"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAdvancedViewerFilter = exports.productsSetTotal = exports.clearSelectedProducts = exports.setSelectedProducts = exports.clearAllSelectedProducts = exports.addSelectedProductIds = exports.addSelectedProductId = exports.setIsExclusionModeOn = exports.productsClearExcludedTaxonomyClassIds = exports.productsClearIncludedTaxonomyClassIds = exports.productsSetExcludedTaxonomyClassIds = exports.clearNotExistTaxonomyClasses = exports.productsSetIncludedTaxonomyClassIds = exports.productsSetExcludedAttributesIds = exports.productsSetIncludedAttributesIds = exports.productsSetExcludedCategoriesIds = exports.productsSetIncludedCategoriesIds = exports.productsSetFilterOperator = exports.productsSetFilterActive = void 0;
const Actions = __importStar(require("../types/products"));
const utils_1 = require("../utils");
const productsSetFilterActive = (type) => ((0, utils_1.createAction)(Actions.PRODUCTS_SET_FILTER_ACTIVE, { type }));
exports.productsSetFilterActive = productsSetFilterActive;
const productsSetFilterOperator = (type) => ((0, utils_1.createAction)(Actions.PRODUCTS_SET_FILTER_OPERATOR, { type }));
exports.productsSetFilterOperator = productsSetFilterOperator;
const productsSetIncludedCategoriesIds = (includedCategoriesIds) => ((0, utils_1.createAction)(Actions.PRODUCTS_SET_INCLUDED_CATEGORIES_IDS, { includedCategoriesIds }));
exports.productsSetIncludedCategoriesIds = productsSetIncludedCategoriesIds;
const productsSetExcludedCategoriesIds = (excludedCategoriesIds) => ((0, utils_1.createAction)(Actions.PRODUCTS_SET_EXCLUDED_CATEGORIES_IDS, { excludedCategoriesIds }));
exports.productsSetExcludedCategoriesIds = productsSetExcludedCategoriesIds;
const productsSetIncludedAttributesIds = (includedAttributesIds) => ((0, utils_1.createAction)(Actions.PRODUCTS_SET_INCLUDED_ATTRIBUTES_IDS, { includedAttributesIds }));
exports.productsSetIncludedAttributesIds = productsSetIncludedAttributesIds;
const productsSetExcludedAttributesIds = (excludedAttributesIds) => ((0, utils_1.createAction)(Actions.PRODUCTS_SET_EXCLUDED_ATTRIBUTES_IDS, { excludedAttributesIds }));
exports.productsSetExcludedAttributesIds = productsSetExcludedAttributesIds;
const productsSetIncludedTaxonomyClassIds = (id) => ((0, utils_1.createAction)(Actions.PRODUCTS_SET_INCLUDED_TAXONOMY_CLASS_IDS, { id }));
exports.productsSetIncludedTaxonomyClassIds = productsSetIncludedTaxonomyClassIds;
const clearNotExistTaxonomyClasses = (ids) => ((0, utils_1.createAction)(Actions.CLEAR_NOT_EXIST_TAXONOMY_CLASSES, { ids }));
exports.clearNotExistTaxonomyClasses = clearNotExistTaxonomyClasses;
const productsSetExcludedTaxonomyClassIds = (id) => ((0, utils_1.createAction)(Actions.PRODUCTS_SET_EXCLUDED_TAXONOMY_CLASS_IDS, { id }));
exports.productsSetExcludedTaxonomyClassIds = productsSetExcludedTaxonomyClassIds;
const productsClearIncludedTaxonomyClassIds = () => (0, utils_1.createAction)(Actions.PRODUCTS_CLEAR_INCLUDED_TAXONOMY_CLASS_IDS);
exports.productsClearIncludedTaxonomyClassIds = productsClearIncludedTaxonomyClassIds;
const productsClearExcludedTaxonomyClassIds = () => (0, utils_1.createAction)(Actions.PRODUCTS_CLEAR_EXCLUDED_TAXONOMY_CLASS_IDS);
exports.productsClearExcludedTaxonomyClassIds = productsClearExcludedTaxonomyClassIds;
const setIsExclusionModeOn = (isExclusionModeOn) => ((0, utils_1.createAction)(Actions.PRODUCTS_SET_IS_EXCLUSION_MODE_ON, { isExclusionModeOn }));
exports.setIsExclusionModeOn = setIsExclusionModeOn;
const addSelectedProductId = (id) => (0, utils_1.createAction)(Actions.PRODUCTS_ADD_SELECTED_ID, { id });
exports.addSelectedProductId = addSelectedProductId;
const addSelectedProductIds = (ids) => ((0, utils_1.createAction)(Actions.PRODUCTS_ADD_SELECTED_IDS, { ids }));
exports.addSelectedProductIds = addSelectedProductIds;
const clearAllSelectedProducts = () => (0, utils_1.createAction)(Actions.PRODUCTS_CLEAR_ALL_SELECTED);
exports.clearAllSelectedProducts = clearAllSelectedProducts;
const setSelectedProducts = (ids) => (0, utils_1.createAction)(Actions.PRODUCTS_SET_SELECTED, { ids });
exports.setSelectedProducts = setSelectedProducts;
const clearSelectedProducts = (ids) => ((0, utils_1.createAction)(Actions.PRODUCTS_CLEAR_SELECTED, { ids }));
exports.clearSelectedProducts = clearSelectedProducts;
const productsSetTotal = (total) => ((0, utils_1.createAction)(Actions.PRODUCTS_SET_TOTAL, { total }));
exports.productsSetTotal = productsSetTotal;
const setAdvancedViewerFilter = (filter) => ((0, utils_1.createAction)(Actions.PRODUCTS_SET_ADVANCED_VIEWER_FILTER, { filter }));
exports.setAdvancedViewerFilter = setAdvancedViewerFilter;
